import { resolveWebappBrand, type WebappBrand } from './brand';

export const LOGO_PATH = '/images/logos/logo.svg';
export const OPUS_WIDE_LOGO_PATH = '/images/logos/opus-wide.png';
export const SMALL_LOGO_PATH = '/images/logos/logo-small.png';
export const QR_PDF_HEADER_LOGO_PATH = '/images/logos/qr-pdf-header-logo.svg';
export const QR_PDF_FOOTER_LOGO_PATH = '/images/logos/qr-pdf-footer-logo.svg';
export const OPUS_LOGO_PATH = '/images/logos/opus-logo.svg';
export const OPUS_SIGN_IN_BACKGROUND_PATH = '/images/sign-in/background-opus.png';

const signInBackgroundByPlatformClient = {
  AETHON: '/images/sign-in/background-aethon.jpg',
  LEVELWORKS: '/images/sign-in/background-level.jpg',
  HOLLANDWORX: '/images/sign-in/background.jpg',
} as const;

export type SignInPlatformClient = keyof typeof signInBackgroundByPlatformClient;

export const WEBAPP_BRAND = resolveWebappBrand(import.meta.env.VITE_BRAND);

export const getWideLogoPath = (brand: WebappBrand): string =>
  brand === 'opus' ? OPUS_WIDE_LOGO_PATH : LOGO_PATH;

export const WIDE_LOGO_PATH = getWideLogoPath(WEBAPP_BRAND);

export const getSignInBackgroundPath = (
  brand: WebappBrand,
  platformClient: SignInPlatformClient
): string =>
  brand === 'opus'
    ? OPUS_SIGN_IN_BACKGROUND_PATH
    : signInBackgroundByPlatformClient[platformClient];

export const getSignInImageOffsets = (
  brand: WebappBrand
): { marginLeft: string; marginTop: string } | undefined =>
  brand === 'opus'
    ? {
        marginLeft: '10rem',
        marginTop: '-5rem',
      }
    : undefined;
